import { Component, Element, Event, EventEmitter, Listen, Prop, State, h } from '@stencil/core';

@Component({
  tag: 'lab-ds-search-bar',
  styleUrl: 'lab-ds-search-bar.css',
  shadow: true,
})
export class LabDsSearchBar {
  @Prop() value!: string;

  @Prop() hints: Array<{ name: string }>;

  @State() isHintVisible: boolean = false;

  @State() valueState: string = this.value;

  @Prop() label: string = '';

  @Prop() disabled: boolean = false;

  @Event() changeInput: EventEmitter<string>;

  handleChange(event) {
    if (event === '') {
      this.changeInput.emit('');
      this.value = '';
      this.valueState = '';
    } else {
      this.changeInput.emit(event.value);
      this.valueState = event.value;
    }
  }

  // eslint-disable-next-line @stencil-community/element-type
  @Element() el: HTMLElement;

  @Listen('click', { target: 'window' })
  checkForClickOutside(ev) {
    if (this.el.contains(ev.target)) {
      return;
    }
    this.isHintVisible = false;
  }

  render() {
    return (
      <div class={`v4-input ${this.disabled && 'disabled'}`}>
        <div onFocusin={() => (this.isHintVisible = true)} class="input-icon">
          <lab-ds-icon-not-selectable class="icon left" size="small" icon="search" />
          <input disabled={this.disabled} placeholder={this.label} class="input-field" type="text" value={this.value} onInput={event => this.handleChange(event.target)} />
          {this.valueState?.length > 0 && (
            <lab-ds-icon-selectable
              onClick={() => {
                this.handleChange('');
              }}
              class={`icon right`}
              size="small"
              icon="close"
            />
          )}
        </div>
        {this.hints?.length > 0 && this.isHintVisible && (
          <div class="options">
            <div class="hints">
              {this.hints?.map((hint, index) => {
                if (index > 4) return null;
                return (
                  <div
                    onClick={() => {
                      this.handleChange({ value: hint.name });
                      this.isHintVisible = false;
                    }}
                    class={'hint-container'}
                  >
                    <lab-ds-icon-not-selectable class={'icon'} size="small" icon="history" />
                    {hint.name}{' '}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    );
  }
}
